import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=69acb483&scoped=true&"
import script from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69acb483",
  null
  
)

export default component.exports